import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { useEnquiry } from '../../context/EnquiryContext';

export const ContactCTA = () => {
  const { open } = useEnquiry();
  return (
    <section data-testid="contact-cta-section" className="bg-bark text-sand py-28 lg:py-40 relative overflow-hidden">
      <span className="absolute -top-10 -right-6 font-serif italic text-[26vw] leading-none text-sand/[0.04] select-none pointer-events-none">P</span>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <motion.p
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[10px] tracking-[0.3em] text-terra font-medium mb-8"
        >
          CHAPTER 05 — BEGIN
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-heading font-extrabold tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-8xl max-w-4xl"
          data-testid="cta-headline"
        >
          Ready to build your <span className="font-serif italic font-medium text-terra">dream home</span>?
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-12 flex flex-col sm:flex-row sm:items-center gap-6"
        >
          <button onClick={open} data-testid="cta-enquire-now-btn"
            className="group bg-terra text-white text-[11px] font-medium tracking-[0.2em] px-10 py-5 flex items-center gap-2 w-max hover:bg-sand hover:text-ink transition-colors duration-300">
            ENQUIRE NOW <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <p className="text-sm text-sand/50 max-w-xs leading-relaxed">
            One conversation is all it takes. Site visit, estimate and timeline — free.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
